import { render } from "./AdressBar.vue?vue&type=template&id=48cd32da&scoped=true"
import script from "./AdressBar.vue?vue&type=script&lang=js"
export * from "./AdressBar.vue?vue&type=script&lang=js"

import "./AdressBar.vue?vue&type=style&index=0&id=48cd32da&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-48cd32da"

export default script